import { createContext } from 'react';
import { dispatchFunc } from '../hook/useEditVirtualMainTablehook';
import { FormInstance } from "antd/lib/form";

export interface IBaseEditVirtualMainTableContext {
  tableDataSource?: any[];
  form?: FormInstance;
  /** 虚拟尾行行数 */
  trailerRow?: number;
  expandedRowKeys?: string[];
  showAddSubRow?: boolean;
  showEmptySubRow?: boolean;
}
export interface IEdiTableContext extends IBaseEditVirtualMainTableContext {
  dispatchEditVirtualMainTable: dispatchFunc;
}
export default createContext<IEdiTableContext>({
  dispatchEditVirtualMainTable: () => {},
});